<div class="o-modal--alert o-modal__warning--naranja o-modal--medium" id="mod-ap-req" style="width: 100%;"> 
    <div class="o-modal__head">
        <a class="o-modal__close close-modal" matDialogClose></a>
        <label class="o-title o-title--white o-title--medium">{{ 'ModalScalePolicyPortal.titleScale' | translate}}</label>
    </div>
    <div class="o-modal__body">
        <p>{{ 'ModalScalePolicyPortal.bodyScale' | translate}}</p>
        <textarea input class="o-form__textarea" placeholder="{{ 'ModalScalePolicyPortal.placeholderComment' | translate}}" [(ngModel)]="observation"></textarea>
    </div>

    <div class="o-modal__footer">
        <div>
            <button mat-button mat-dialog-close class="btn btn--default"><u>{{ 'ModalScalePolicyPortal.btnCancel' | translate }}</u></button>
            <button mat-button class="btn btn--primary" (click)="onSubmit()">{{ 'ModalScalePolicyPortal.btnScale'| translate }}</button>
        </div>
    </div>
</div>